import cx from 'clsx';
import React from 'react';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Links } from '../../../components/links';
const getPlanIcon = (plan) => {
    const option = {
        pro: 'https://assets.designs.ai/images/procrown.svg',
        basic: 'https://assets.designs.ai/images/svg/icon-avatar.svg',
        free: 'https://assets.designs.ai/images/svg/icon-avatar.svg',
        lite: 'https://assets.designs.ai/images/svg/icon-avatar.svg',
        enterprise: 'https://assets.designs.ai/images/svg/icon-enterprise.svg',
        default: 'https://assets.designs.ai/images/svg/icon-avatar.svg'
    };
    return option[plan || 'default'];
};
export const LoginMenu = ({ styles, user, onAction, intl, additionalMenu, profile, initial }) => {
    var _a, _b, _c;
    return (React.createElement("div", { className: styles.category },
        React.createElement("div", { className: cx(styles.avatarWrapper) },
            profile ? (React.createElement("img", { src: profile, alt: 'profile', className: cx(styles.avatar), onError: (ev) => (ev.target.src =
                    'https://assets.designs.ai/images/svg/icon-avatar.svg') })) : user.name ? (React.createElement("div", { style: {
                    color: 'white',
                    width: '25px',
                    height: '25px',
                    borderRadius: '50%',
                    background: '#4519EF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontFamily: 'Poppins-Regular'
                } }, initial)) : (React.createElement("img", { width: 48, height: 48, alt: 'profile', style: {
                    borderRadius: '50%'
                }, src: 'https://assets.designs.ai/images/svg/icon-avatar.svg' })),
            React.createElement(ExpandMore, { className: styles.svg })),
        React.createElement("div", { className: cx(styles.product, styles.login_menu) },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("div", { className: styles.username }, ((_a = user === null || user === void 0 ? void 0 : user.name) === null || _a === void 0 ? void 0 : _a.length) > 17
                        ? (user === null || user === void 0 ? void 0 : user.name.substr(0, 17)) + '...'
                        : user === null || user === void 0 ? void 0 : user.name),
                    user.subscription && (React.createElement(Links, { to: '/user/account/my-plan', className: styles.userPlan },
                        React.createElement("img", { width: '28px', height: '28px', alt: 'Designs.ai Pro crown', src: getPlanIcon((_b = user === null || user === void 0 ? void 0 : user.subscription) === null || _b === void 0 ? void 0 : _b.sub_category) }), (_c = user.subscription.sub_plan_name) !== null && _c !== void 0 ? _c : ''))),
                React.createElement("hr", { className: styles.menu_hr }),
                React.createElement("div", { className: styles.login_bottom },
                    React.createElement(Links, { to: '/user/dashboard', className: styles.login_link },
                        React.createElement("img", { alt: 'sign_out', src: 'https://assets.designs.ai/images/svg/icon-dashboard.svg' }), intl === null || intl === void 0 ? void 0 :
                        intl.formatMessage({
                            id: 'dashboard',
                            defaultMessage: 'Dashboard'
                        })),
                    React.createElement(Links, { to: '/user/account/settings', className: styles.login_link },
                        React.createElement("img", { alt: 'sign_out', src: 'https://assets.designs.ai/images/svg/icon-settings.svg' }), intl === null || intl === void 0 ? void 0 :
                        intl.formatMessage({
                            id: 'account_settings',
                            defaultMessage: 'Account Settings'
                        })), additionalMenu === null || additionalMenu === void 0 ? void 0 :
                    additionalMenu.map((menu, i) => (React.createElement("a", { href: menu.href, key: i, onClick: (e) => {
                            e.preventDefault();
                            menu.callback();
                        }, className: styles.login_link }, menu.linkName))),
                    React.createElement("a", { className: styles.login_link, onClick: () => onAction({ action: 'logout' }) },
                        React.createElement("img", { alt: 'sign_out', src: 'https://assets.designs.ai/images/svg/icon-logout.svg' }), intl === null || intl === void 0 ? void 0 :
                        intl.formatMessage({
                            id: 'sign_out',
                            defaultMessage: 'Sign out'
                        })))))));
};
//# sourceMappingURL=LoginMenu.js.map